export default {
    company: {
        name: "宜賓紙業株式会社"
    },
    nav: {
        home: "ホーム",
        about: "企業情報",
        products: "製品ラインナップ",
        contact: "コンタクト",
        sustainability: "サステナビリティ",
        technology: "技術開発"
    },
    banner: {
        title: "竹の香り高い紙・エコフレンドリーな未来",
        subtitle: "千年の製紙技術を継承し、竹パルプ製紙の新基準を確立"
    },
    products: {
        subtitle: "高品質な竹パルペーパーで多様なニーズにお応えします",
        description: "原紙から加工品まで、トータルな紙製品ソリューションを提供",
        viewDetails: "詳しくはこちら",
        categories: {
            title: "製品カテゴリー",
            subtitle: "竹パルプ製品でエコ消費の新潮流を創出",
            livingPaper: "家庭用紙原紙",
            livingPaperDesc: "家庭用紙原紙シリーズ",
            foodPaper: "食品包装原紙",
            foodPaperDesc: "食品包装原紙シリーズ",
            finishedProducts: "家庭用紙製品シリーズ"
        },
        advantages: {
            title: "製品の特長",
            subtitle: "竹の恵みで、上質な暮らしを"
        },
        applications: {
            title: "主な用途",
            subtitle: "日常生活から産業用途まで幅広く活用"
        },
        cta: {
            title: "オリジナル製品のご要望ですか？",
            description: "竹パルプ紙製品のオーダーメイド対応が可能です",
            buttonText: "ご相談はこちら"
        },
        detail: {
            features: '商品特徴',
            contactUs: 'ご相談はこちら',
            specifications: '製品スペック',
            usageScenarios: '使用例',
            relatedProducts: '関連商品',
            cta: {
                title: '製品詳細をお求めですか？',
                description: '専門スタッフがご要望に合わせてご提案いたします',
                buttonText: 'ご相談はこちら'
            }
        },
        title: "主力製品"
    },
    advantages: {
        title: "競争力の源泉",
        subtitle: "竹パルプ製紙技術と環境配慮、そして卓越した品質",
        items: {
            experience: {
                title: "豊富な業界経験",
                description: "80年の技術蓄積と完全なサプライチェーンで、バイオマス材料転換を強力に支援。"
            },
            production: {
                title: "成熟した量産システム",
                description: "充実した生産設備と自動化ラインで、高効率な量産を実現。"
            },
            innovation: {
                title: "産学連携による技術開発",
                description: "大学・研究機関と共同で低環境負荷技術の実用化を推進。"
            },
            certification: {
                title: "サプライチェーン全体の環境認証",
                description: "FSC認証など国際基準を取得し、市場競争力を強化。"
            }
        }
    },
    footer: {
        contact: "ご相談はこちら",
        address: "四川省宜賓市南渓区裴石工業団地 宜賓紙業株式会社",
        phone: "TEL: 0831-3309663",
        email: "Email: ybzy@yb-zy.com",
        quickLinks: "ショートカット",
        moreInfo: "詳細情報",
        news: "ニュースリリース",
        careers: "採用情報",
        informations: "情報公開",
        followUs: "SNS",
        wechat: "WeChat: 宜賓紙業",
        rights: "© Yibin Paper Co., Ltd.",
        slogan: "竹パルプで創る、サステナブルな革新",
        ICPfiling: "蜀ICP备05027078号-1",
        PublicSecurityFiling: "川公网安备51150302000130号"
    },
    about: {
        companyProfile: "企業プロフィール",
        established: "1944年創業",
        formerName: `前身は「中国製紙所」`,
        firstNewsprint: "国産初の機械抄き新聞紙製造に成功",
        listed: "1997年上海証券取引所上場（SH:600793）",
        firstListed: "中国製紙業界初の上場企業",
        firstYibinListed: "宜賓市初の上場企業",
        wuliangyeSubsidiary: "五糧液集団持株会社の主要子会社",
        firstNewMeterial: "国家認定「60+10」新型竹素材フラッグシップ企業",
        capacity: "生産能力",
        mainCapacity: "本社工場：年間約54万トンの抄紙能力",
        managedCapacity: "管理工場：年間約12万トンの抄紙能力",
        newMaterialCapacity: "新素材段ボール：年間1億m²生産可能",
        bambooMoldingCapacity: "竹パルプ成型加工品：年間6,600トン",
        celluloseCapacity: "セルロースアセテート：年間3万トン",
        historyTitle: "企業沿革",
        historySubtitle: "70年以上の歴史で築いた竹パルプ製紙のパイオニア",
        historyItems: {
            "1944": "「中国製紙所」として創業",
            "1945": "国産初の機械パルプ新聞紙製造成功",
            "1950": `「宜賓製紙工場」に改称`,
            "1961": "国家指導者視察（朱德氏）",
            "1966": "国家指導者視察（彭徳懐氏）",
            "1988": "株式制改革実施",
            "1997": "上海証券取引所に上場",
            "2012": "新工場建設プロジェクト開始",
            "2015": "食品包装用原紙新ライン稼働",
            "2018_1": "生活用紙新ライン稼働",
            "2018_2": "五糧液集団傘下に",
            "2025": "現在 バイオベース素材総合メーカーへ転換中"
        },
        futureDevelopment: "未来ビジョン",
        future: {
            point1: "戦略目標の達成に注力",
            point2: "竹資源の特性を最大限活用",
            point3: "特殊分野・高付加価値事業への転換加速",
            point4: "紙製品ニッチ市場でのグローバルリーダーを目指す"
        },
        coreValues: "経営理念",
        coreValuesSubtitle: "「竹の技術」と「紙の文化」で持続可能な未来へ",
        values: {
            mission: "企業使命",
            missionLine1: "バイオ新素材で",
            missionLine2: "カーボンニュートラルな世界を創造",
            vision: "企業ビジョン",
            visionLine1: "グリーン素材の",
            visionLine2: "総合メーカーを目指して",
            coreValues: "コアバリュー",
            coreValuesLine1: "品質至上・革新重視",
            coreValuesLine2: "持続可能な成長・共創の精神",
            philosophy: "事業方針",
            philosophyLine1: "顧客本位の経営",
            philosophyLine2: "品質を基盤に 革新で成長する  以创新为动力"
        },
        certificationsTitle: "取得認証",
        certificationsSubtitle: "業界認証品質保証",
        certificationItems: {
            fsc: "FSC森林認証",
            fscDesc: "持続可能な森林資源の利用認証",
            iso9001: "ISO9001品質認証",
            iso9001Desc: "国際品質マネジメントシステム認証",
            iso14001: "FSSC22000食品安全認証",
            iso14001Desc: "食品安全管理システム国際認証",
            medical: "医療用品級認証",
            medicalDesc: "医療用製品品質認証書",
            antibacterial: "抗菌加工製品認証",
            antibacterialDesc: "抗菌効果認定証",
            safety: "衛生安全基準認証",
            safetyDesc: "衛生安全製品認定書"
        },
        honorsTitle: "受賞歴",
        honorsSubtitle: "業界認証品質保証",
        honorItems: {
            greenFactory: "国家認定グリーン工場",
            greenFactoryDesc: "工業情報化省認定 環境配慮型モデル企業",
            forestryLeader: "国家林業局指定 重点企業",
            forestryLeaderDesc: "林業草原局認定 業界リーダー企業",
            agriculturalProduct: "中国優良農産品メーカー",
            agriculturalProductDesc: "中国優良農産品ブランド",
            lightIndustry: "全国軽工業優秀企業",
            lightIndustryDesc: "全国軽工業優秀企業",
            bambooProduct: "竹製品トップ10企業",
            bambooProductDesc: "中国竹産業ブランドトップ10",
            engineeringCenter: "製紙技術研究センター",
            engineeringCenterDesc: "四川省竹パルプ製紙技術研究拠点"
        },
        productHonorsTitle: "製品受賞歴",
        productHonorsSubtitle: "業界認証品質保証",
        productHonorItems: {
            industryExcellence: "業界最高品質製品賞",
            neZhaExcellence: "2025年 生活用紙「哪吒」シリーズ最高品質賞",
            moDiKaExcellence: "生活用紙「モディカ」シリーズ品質最優秀賞",
            bambooExpoGold: "国際竹産業博覧会 金賞",
            moDiKaGold: "2025年「モディカ」シリーズ竹博金賞",
            shanghaiExpoGold: "国際竹産業博覧会 金賞",
            jinZhuGold: "2020年上海竹博「金竹」シリーズ金賞",
            quanZhuGold: "2018年上海竹博 竹100%包装用紙金賞",
            westernExpoGold: "中国西部林業博 金賞",
            jinZhuWesternGold: "西部林業博「金竹」シリーズ金賞"
        },
        cta: {
            title: "宜賓紙業にご加入いただき、緑の未来を共に創りましょう",
            description: "皆様と手を携え、竹パルプ製紙産業の持続可能な発展を共に推進することを心よりお待ちしております",
            buttonText: "ご相談はこちら"
        }
    },
    technology: {
        title: '技術革新',
        subtitle: '科学技術が導き、グリーン革新を推進し、竹パルプ製紙業界の新たな基準を確立',
        innovation: {
            title: '革新による発展の推進',
            subtitle: '科学技術が導き、グリーン革新を推進し、竹パルプ製紙業界の新たな基準を確立',
            management: {
                title: '効率的に連携する革新管理システム',
                content: '宜宾紙業は、技術革新を企業成長の「中核的な推進力」と位置付け、研究開発・生産・市場戦略を統合的に調整する「経営戦略委員会」を設置。「本社技術開発部門」と「生産基地」を連携させたイノベーション体制を構築し、柔軟なインセンティブ制度を導入することで、技術開発から実用化までのプロセスを円滑に推進しています。'
            },
            team: {
                title: '専門チームが技術ブレークスルーを牽引',
                content: '省級イノベーションプラットフォームと研究開発・イノベーションチームを基盤とし、複数の有名大学や研究機関と緊密に連携し、低炭素パルプ製造、バイオベース材料などのフロンティア分野に焦点を当てた研究開発プロジェクトを展開し、企業の革新的発展に強力な原動力を提供しています。'
            },
            results: {
                title: '革新の成果が産業の高度化を促進',
                content: '竹材パルプ製紙の全工程における中核技術を掌握し、技術革新を通じてグリーンパルプ製造、クリーン生産、資源総合利用などの分野で継続的にブレークスルーを達成し、企業のグリーン・低炭素バイオベース材料産業への転換・高度化を牽引しています。'
            }
        },
        core: {
            title: '中核技術',
            subtitle: '科学技術が導き、グリーンイノベーションを推進',
            tabs: {
                pulping: '竹材パルプ製造技術',
                bleaching: '循環経済の中核技術',
                papermaking: 'グリーン製品の革新技術'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: '竹材前処理技術体系',
                            content: '竹材の高密度・高ケイ素含有量という処理の難題を突破し、竹材均質浸漬技術を開発し、エネルギー消費を10％以上削減。'
                        },
                        {
                            title: '低炭素・クリーンパルプ製造技術',
                            content: '「深度脱リグニン-ECF漂白」併用プロセスにより、AOX（吸着性有機ハロゲン化合物）排出量を国家基準比30％以上低減。「嫌気性+好気性+フェントン」水処理技術を統合し、COD（化学的酸素要求量）排出量を国家基準比50％以上低減。'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: '竹材全成分利用技術',
                            content: '竹セルロースはパルプ・製紙に利用。黒液リグニンは燃焼させ熱エネルギーを回収、パルプ1トン当たり350kWhの発電が可能。製漿廃棄物はバイオ肥料を製造し自然に還元。'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: '機能性竹繊維製品',
                            content: '竹繊維強化技術により、包装紙の引張強度・耐折強度指標を50％以上向上させ、製品性能を強化。竹材の天然抗菌成分を利用した自己抗菌家庭紙製品を開発し、同等条件下で抗菌効率を90％以上向上。'
                        },
                        {
                            title: 'バイオベース新素材',
                            content: '竹繊維製品がプラスチック製品を代替し、カーボンフットプリントを60％削減。'
                        }
                    ]
                }
            }
        },
        research: {
            title: '研究開発センター',
            subtitle: '研究開発に専念し、価値を創造',
            imageAlt: '宜賓紙業研究開発センター',
            center: {
                title: '研究開発・イノベーションプラットフォーム',
                content: '研究開発センターは2003年に設立され、当社の技術革新の中核部門として、業界のトレンドに焦点を当て、科学技術成果の実用化を推進しています。当社は現在、省級企業技術センターであり、四川省竹材パルプ製紙工程技术研究中心など2つの省級イノベーションプラットフォームを有しています。「新型竹産業産学融合共同体」の設立を主導し、「竹パルプ・紙一貫化重要技術研究」国家重点プロジェクトに参画しています。竹パルプ・紙生産の重要技術分野で豊富な経験を蓄積し、強い技術的競争優位性を形成しています。'
            },
            cooperation: {
                title: '共同研究開発',
                content: 'センターは四川農業大学、華南理工大学、北京林業大学、南京林業大学、中国林業科学研究院など、多数の大学・研究機関と長期的な協力関係を構築し、国家および省・部レベルの科学研究プロジェクトを共同で担当し、産学研の深い融合を推進しています。'
            }
        },
        patents: {
            title: '特許と成果',
            subtitle: '技術の蓄積、業界のリーダーシップ',
            authorized: {
                title: '取得特許',
                items: [
                    '精製混合竹パルプ及びその製造方法、並びに該精製混合竹パルプの製紙への応用',
                    '精製竹パルプ及びその製造方法、並びに該精製竹パルプの製紙への応用',
                    'アルカリ回収ボイラー用黒液噴射ガン',
                    '繊維選別装置'
                ]
            },
            projects: {
                title: '科学研究プロジェクト',
                items: [
                    '嵩高・高強度竹パルプのクリーン・省エネ製造及び高強度包装用ボール紙の配合抄紙技術研究',
                    '竹材化学パルプの精製及び高級家庭紙配合抄紙技術研究',
                    '竹ベースパルプの精深加工技術研究・開発',
                    '竹ベース高品質セルロース繊維の研究・開発',
                    '機能性リグニンの高付加価値製品研究・開発'
                ]
            },
            awards: {
                title: '科学技術賞',
                items: [
                    '四川省科学技術進歩一等賞'
                ]
            },
            papers: {
                title: '研究論文',
                items: [
                    '陽イオン分散ロジンサイズ中の総ロジン及び硫酸アルミニウム含有量の測定',
                    '竹を含む化学機械パルプ使用の未晒食品用カートンの試作',
                    '蒸解助剤の全竹材DDS蒸解への応用',
                    '繊維分級による竹繊維資源の溶解パルプ生産における高効率利用の新プロセス：実験室研究と工場試験',
                    'リグニン価値化のための光触媒予酸化-超音波キャビテーション解重合タンデム戦略によるリグニンの高付加価値利用'
                ]
            }
        },
        projects: {
            title: '革新プロジェクト',
            subtitle: '業界の未来の発展方向を牽引',
            items: [
                {
                    title: '四川竹産業チェーン重要技術統合・デモンストレーション工場',
                    period: '2019-2022',
                    cooperation: '四川農業大学',
                    desc: '竹資源チェーンと産業チェーンを有機的に融合し、竹産業の発展を推進。'
                },
                {
                    title: '宜賓林竹産業ハイテクイノベーションプラットフォーム構築・デモンストレーション',
                    period: '2019-2022',
                    cooperation: '華南理工大学',
                    desc: '竹材低硫蒸解技術、黒液高付加価値利用技術などでブレークスルーを達成。'
                },
                {
                    title: '竹ベースパルプ精深加工技術研究・開発',
                    period: '2022-2024',
                    cooperation: '中国林業科学研究院',
                    desc: '竹材高収率パルプ製造などの重要技術を突破し、産業化を進め、原材料の輸入代替を実現。'
                },
                {
                    title: '機能性リグニン高付加価値製品研究・開発',
                    period: '2022-2024',
                    cooperation: '北京林業大学',
                    desc: '竹パルプ製造黒液からリグニン成分を分級抽出し副産物を製造することで、黒液の高付加価値利用経路を突破。'
                },
                {
                    title: '竹パルプ・紙一貫化重要技術研究',
                    period: '2023-2028',
                    cooperation: '中国林業科学研究院',
                    desc: '高効率均質浸漬軟化、高精度解離・省エネ叩解、アルカリ過酸化水素活性化漂白などの重要技術。'
                },
                {
                    title: 'スマート竹産業重要技術研究・統合デモンストレーション',
                    period: '2024-2027',
                    cooperation: '南京林業大学',
                    desc: '竹パルプ製紙企業のクリーン製造、資源総合利用などの重要技術課題をテーマに研究を展開。'
                }
            ]
        },
        cta: {
            title: '竹パルプ製紙の未来を共に探求',
            subtitle: '竹パルプ・紙技術革新に志を持つパートナーの皆様からのご連絡をお待ちし、業界の発展を共に推進します',
            button: 'ご相談はこちら'
        }
    },
    sustainability: {
        title: '持続可能な発展',
        subtitle: '竹を基盤とし、革新を翼として、グリーン・低炭素バイオベース材料産業のモデルを創出',
        vision: {
            title: '持続可能な発展ビジョン',
            content: '竹を基盤とし、革新を翼として、グリーン・低炭素バイオベース材料産業のモデルを創出',
            imageAlt: '宜賓紙業 持続可能な発展ビジョン',
            intro1: '竹材パルプ製紙業界の革新者として、',
            intro2: '宜賓紙業は「竹資源の高効率利用＋低炭素技術」を中核に据え、伝統産業のグリーン化、高付加価値化、循環型への転換を推進します。',
            items: {
                circular: {
                    title: 'グリーン・低炭素で循環経済を牽引',
                    content: '竹材の再生可能、速生・炭素固定という特性を活かし、「竹資源—クリーンパルプ製造—バイオベース材料—低炭素製品」の全産業チェーンを構築し、「廃棄物ゼロ、全資源利用」を実現し、30/60「ダブルカーボン」目標達成に貢献します。'
                },
                innovation: {
                    title: '科学技術革新が高付加価値転換を推進',
                    content: '竹繊維の高付加価値利用技術を突破し、生分解性包装、バイオベース複合材料などのプラスチック代替新製品を開発し、ライフサイクル全体のカーボンフットプリントを削減します。'
                },
                rural: {
                    title: 'エコロジカルな共創で、農村振興を強化',
                    content: '「竹林基地＋グリーン工場＋コミュニティ共生」モデルを通じて、竹林の炭素吸収源（カーボンシンク）による収益向上を促進し、産業チェーン上流・下流の連携した発展を牽引し、環境的利益、経済的利益、社会的利益の統一を実現します。'
                },
                cooperation: {
                    title: 'オープンな協働で、持続可能な未来を共創',
                    content: '研究機関や産業チェーンパートナーと連携し、竹ベース材料の規格制定と技術普及・応用を推進し、「竹によるプラスチック代替」「竹による木材代替」をグローバルなグリーンソリューションとします。'
                }
            },
            commitment: {
                title: '私たちの約束：',
                content: '一本一本の竹が、自然と技術の共生です。一つ一つの革新が、地球と人類の未来です。'
            }
        },
        cleanProduction: {
            title: 'クリーン生産',
            subtitle: '革新技術で緑の水と青い山を守り、クリーン生産で持続可能な発展を牽引',
            description: '宜賓紙業は竹材パルプ製紙業界のグリーンリーダーとして、常に「環境保護優先、グリーン発展」の理念を実践し、クリーン生産プロセス、資源循環利用、低炭素技術革新を通じて、効率的でクリーン、持続可能な近代的な製紙産業を構築し、グローバルな顧客にグリーンな紙製品ソリューションを提供しています。',
            items: {
                raw: {
                    title: 'グリーン原料、低炭素源流',
                    subtitle: '100%持続可能な竹繊維、生産廃棄物の総合利用',
                    points: [
                        '速生竹林資源を採用し、森林伐採を削減',
                        '竹材の生育過程で高い炭素固定能力を発揮し、源流でカーボン排出を削減',
                        '竹屑、白泥などの生産廃棄物の総合利用経路を模索し、資源の高効率循環を実現'
                    ]
                },
                process: {
                    title: 'クリーンな工程、省エネ・消費削減',
                    subtitle: '低汚染パルプ製造技術、排水・排ガスの超低排出',
                    points: [
                        '無塩素元素漂白（ECF）、酸素脱リグニンなどの先進プロセスを採用し、AOX（吸着性有機ハロゲン化合物）などの有害物質排出を大幅に削減',
                        '嫌気性+好気性生物処理などの技術を組み合わせ、排水の基準達成を実現。処理水を原料洗浄に再利用し、真水の消費を削減',
                        'アルカリ回収ボイラー＋電気集塵装置＋湿式脱硫システムを装備し、排ガス排出を国家基準よりも優れたレベルで確保'
                    ]
                },
                recycle: {
                    title: '循環経済、廃棄物を宝物に',
                    subtitle: '黒液100％回収、汚泥の資源化、廃熱の再利用',
                    points: [
                        '製漿廃液をアルカリ回収システムで熱エネルギー及び化学品に転換し、自給率85％超を達成。化石エネルギーへの依存を削減',
                        '製紙汚泥は有機肥料またはバイオマス燃料の生産に利用し、固形廃棄物の「ゼロ埋立」を実現',
                        '生産工程の廃熱を発電に利用し、エネルギー利用効率を向上'
                    ]
                },
                product: {
                    title: 'グリーン製品、低炭素生活',
                    subtitle: '生分解性包装紙、FSC認証製品',
                    points: [
                        '竹繊維食品グレード包装紙はプラスチック製品を代替し、「白色汚染」を削減',
                        '紙の原料源が国際的な森林の持続可能な経営基準に適合していることを確保し、ハイエンド市場の需要を満たす'
                    ]
                }
            }
        },
        circularEconomy: {
            title: '循環経済',
            subtitle: '竹を余すところなく活用し、永続的に循環',
            imageAlt: '循環経済モデル図',
            intro: {
                title: '竹で木を代替し、緑で力を与える',
                content: '竹資源の高効率利用の提唱者として、私たちは「竹→パルプ→紙→エネルギー→肥料」の5点一体型循環経済モデルを構築し、一本一本の竹にグリーンエネルギーを吹き込んでいます。'
            },
            items: {
                source: {
                    title: 'グリーンスタート：持続可能な竹の源',
                    points: [
                        '生態竹林モデル基地を設立し、輪伐管理モデルを採用。',
                        '竹材の成長速度は速く（3-5年で成材）、炭素固定能力は杉の1.5倍。',
                        '10万戸の農家の収入増加を牽引し、「緑の水と青い山」から「金と銀の山」への転換を実現。'
                    ]
                },
                core: {
                    title: '中核循環：三廃（廃液・廃ガス・廃渣）ゼロ排出',
                    points: [
                        '廃液→エネルギー：製漿黒液100％回収、年間発電量0.6億kWh。',
                        '廃ガス→資源：ボイラー排ガスの廃熱を再利用し、CO2排出を削減。',
                        '廃渣→炭素源：竹屑をバイオマスペレット燃料に製造。'
                    ]
                },
                upgrade: {
                    title: '製品高度化：竹の全利用',
                    points: [
                        '高級竹パルプ食品包装、家庭紙（FSC認証）。',
                        '竹繊維生分解性包装材料（プラスチック代替）。',
                        '竹屑・竹滓をバイオマス原料として利用。'
                    ]
                }
            },
            vision: {
                title: '私たちのビジョン：',
                content: '一本一本の竹が、炭素吸収源から製品へと至るグリーンの旅を完遂することを。'
            }
        },
        socialResponsibility: {
            title: '社会的責任',
            subtitle: '静かに万物を潤し、善行を広く行き渡らせる',
            tabs: {
                community: 'コミュニティ発展',
                farmers: '農家支援・収入増加',
                education: '人材育成',
                biodiversity: '環境に優しい取り組み'
            },
            community: {
                title: '農村振興計画',
                description: '宜賓紙業は国家の農村振興戦略に積極的に呼応し、「企業＋協同組合＋農家」モデルを通じて、周辺農村の竹産業発展を牽引し、農村経済の活性化を図っています。',
                items: {
                    village: {
                        title: '駐在支援',
                        content: '当社はこれまでに、翠屏区永興鎮獅子村に駐在する第一書記として党員幹部2名を派遣し、江安県陽春鎮興旺村に駐在工作隊員として党員幹部1名を派遣しました。'
                    },
                    manager: {
                        title: '集団経済専門経営者',
                        content1: 'これまでに2名の幹部人材を村に派遣し「専門経営者」として、村の財政監督、制度整備、市場開拓、製品マーケティング、経営能力者の育成などに取り組み、村の集団経済の規範化、市場化、専門化レベルの向上に貢献しています。',
                    },
                    project: {
                        title: '興文県大河ミャオ族郷産業発展協力共創1対1連携プロジェクト',
                        content: '『宜賓市企業と民族郷の連携による共創1対1連携メカニズム運営方案』の作業要求に基づき、当社は興文県大河ミャオ族郷と連携し、竹原料の販売難問題の解決にあたっています。'
                    }
                }
            },
            farmers: {
                title: '農家支援・収入増加プロジェクト',
                description: '私たちは地元の竹農家と安定した協力関係を構築し、直採購入モデル、スマート装備の導入、科学的育種の普及などの施策を通じて、竹農家の収入増加を支援し、共同富裕を実現しています。',
                imageAlt: '農家支援・収入増加プロジェクト',
                items: {
                    direct: {
                        title: '直採購入による中間業者排除で竹農家の利益を保護',
                        content1: '従来の買付モデルを打破し、「企業＋専門協同組合集荷場＋農家」、「企業＋自社建設集荷場＋農家」など多様な直採購入モデルを確立。',
                        content2: '第一次産業と第二次産業の深い連携を強化し、中間業者を排除。各工程のコスト削減の可能性を掘り起こし、原料供給を確保すると同時に、竹農家の竹販売を容易にし、竹価格を安定させ、竹農家の利益を保護します。'
                    },
                    tech: {
                        title: '技術による産業高度化で竹農家の収入向上',
                        content1: 'スマート装備への投資を拡大し、竹の伐採・輸送工程を中心に、竹伐採機・竹輸送機の研究開発を進めています。',
                        content2: '竹の伐採・輸送効率を全面的に向上させ、労働力を完全に解放し、伐採コストを削減。技術革新の恩恵を竹農家と共有し、竹農家の収入を増やします。',
                        content3: '科学的な育種、植栽、管理・保護のモデルケースを通じて、竹林の高生産性を示範・牽引する効果を実現。',
                        content4: '竹農家に科学的な植栽を指導し、植栽・管理コストを削減し、単位面積あたりの収量を向上させ、竹農家の竹栽培収益を増やします。'
                    },
                    value: {
                        title: '付加価値協力で経路を拡大、総合収益を向上',
                        content1: '多様な協力モデルを積極的に模索し、竹林の「非木材収益」を活性化。第三機関と連携し竹林炭素吸収源（カーボンシンク）取引のパイロット事業を実施しており、農家は管理・保護の成果に基づき追加の配当を得られます。',
                        content2: '同時に林下種植・養殖の発展を導き、竹林の総合収益を向上。林下経済と炭素吸収源経営を組み合わせ、竹林の炭素固定能力を高め、農家の収入を増やし、「生態＋経済」の両立を実現します。'
                    }
                }
            },
            education: {
                title: '竹材人材育成計画',
                description: '人材は発展を推進する中核エンジンです。私たちは人材育成を重視し、多様な人材育成メカニズムを構築することで、業界の未来の人材を育成します。',
                imageAlt: '人材育成プロジェクト',
                items: {
                    mechanism: {
                        title: '多様な人材育成メカニズム',
                        content: '「師匠が弟子を指導する」方式、後継人材の育成、ローテーション実践、カスタマイズ研修コースなどのメカニズムを通じて、社員が新卒から業界のエリートへと成長する変革を支援します。'
                    },
                    path: {
                        title: '充実した成長パス',
                        content: '絶えず改善される昇進ルートと多様なキャリアパスにより、各メンバーが得意分野で価値を発揮し、会社と共に成長の新たな旅へと進むことができます。'
                    }
                }
            },
            biodiversity: {
                title: 'グリーン工場計画',
                description: '私たちは国家の「ダブルカーボン」目標に積極的に応え、持続可能な発展を戦略的重点と位置付け、環境管理システムを継続的に最適化しています。',
                imageAlt: '環境に優しいプロジェクト',
                items: {
                    policy: {
                        title: '「竹で木を代替」「竹でプラスチックを代替」',
                        content: '政府の「竹で木を代替」「竹でプラスチックを代替」政策の呼びかけに積極的に応え、生産が天然資源に与える影響を低減し、低炭素経済への移行を図り、経済的利益と環境的利益の両立を実現します。'
                    },
                    factory: {
                        title: 'グリーン工場',
                        content: 'FSC FM/CoC森林認証を取得し、国家クラス「グリーン工場」企業、四川省「クリーン生産」企業に選定されています。製品は「四川省省エネ・環境保護ブランド優秀製品賞」を受賞。'
                    }
                }
            }
        },
        report: {
            title: '持続可能な発展報告書',
            subtitle: '透明で、真実かつ包括的な持続可能な発展情報の開示',
            download: '報告書ダウンロード',
            items: {
                '2024': {
                    title: '2024年持続可能な発展報告書',
                    date: '発行日：2024年4月',
                    imageAlt: '2024年持続可能な発展報告書'
                },
                '2023': {
                    title: '2023年持続可能な発展報告書',
                    date: '発行日：2023年4月',
                    imageAlt: '2023年持続可能な発展報告書'
                }
            }
        },
        cta: {
            title: '私たちと共に、持続可能な未来を創りましょう',
            description: '宜賓紙業の持続可能な発展の取り組みをもっと知りたい、またはグリーン発展の推進で当社と協力したい場合は',
            buttonText: 'ご相談はこちら'
        }
    },
    home: {
        advantages: {
            title: "競争力の源泉",
            subtitle: "竹パルプ製紙技術と環境配慮、そして卓越した品質",
            items: {
                experience: {
                    title: "豊富な業界経験",
                    description: "80年の技術蓄積と完全なサプライチェーンで、バイオマス材料転換を強力に支援。"
                },
                production: {
                    title: "成熟した量産システム",
                    description: "充実した生産設備と自動化ラインで、高効率な量産を実現。"
                },
                innovation: {
                    title: "産学連携による技術開発",
                    description: "大学・研究機関と共同で低環境負荷技術の実用化を推進。"
                },
                certification: {
                    title: "サプライチェーン全体の環境認証",
                    description: "FSC認証など国際基準を取得し、市場競争力を強化。"
                }
            }
        },
        products: {
            title: "主力製品",
            subtitle: "高品質な竹パルペーパーで多様なニーズにお応えします",
            items: {
                bambooPulp: {
                    title: "バージン竹パルプ",
                    description: "厳選された竹種、良質な竹繊維",
                    alt: "竹パルプ"
                },
                packagingPaper: {
                    title: "バージン竹パルプ包装用紙",
                    description: "強度良好、耐折性高く、高清浄度",
                    alt: "包装用紙"
                },
                culturalPaper: {
                    title: "バージン竹パルプ文化用紙",
                    description: "滑らかで繊細、書き心地・印刷適性に優れる",
                    alt: "文化用紙"
                },
                livingPaper: {
                    title: "バージン竹パルプ家庭用原紙",
                    description: "濡れても強靭、グリーンで環境に優しい",
                    alt: "家庭用原紙"
                },
                finishedPaper: {
                    title: "バージン竹パルプ家庭用製品紙",
                    description: "柔軟で快適、健康で抗菌",
                    alt: "家庭用製品紙"
                },
                fiberMaterial: {
                    title: "繊維材料",
                    description: "機能多様、様々な特殊ニーズに対応",
                    alt: "繊維材料"
                },
                learnMore: "詳細はこちら"
            }
        },
        about: {
            title: "宜賓紙業について",
            description1: "宜賓紙業株式会社は1944年に創立され、中国を代表する竹パルプ・紙生産企業として、竹のパルプ化・製紙の研究と生産に注力しています。",
            description2: "本社は四川省宜賓市に位置し、豊富な竹資源と先進的な生産設備を有し、年間50万トン以上の高品質竹パルプ・紙の生産能力を誇ります。",
            description3: "技術革新とグリーン生産を通じて、顧客に優れた環境に優しい紙製品を提供すると同時に、製紙業界の持続可能な発展を推進することに努めています。",
            learnMore: "詳細はこちら"
        },
        sustainability: {
            title: "持続可能な発展",
            subtitle: "竹パルプ製紙、グリーン循環",
            items: {
                renewable: {
                    title: "竹の源は再生可能",
                    description: "竹は3-5年で成熟・伐採可能、成長が速く、理想的な再生可能な製紙原料"
                },
                carbon: {
                    title: "炭素吸収源としての貢献",
                    description: "竹林は同面積の森林より多くのCO₂を吸収し、気候変動の緩和に効果的"
                },
                clean: {
                    title: "クリーン生産",
                    description: "閉鎖循環生産プロセスを採用、排水処理・再利用により省エネ・排出削減を実現"
                },
                rural: {
                    title: "農村振興",
                    description: "竹農家の収入増加を牽引、地元経済の発展を促進、生態と経済の両立を実現"
                }
            }
        },
        cta: {
            title: "私たちと協力し、グリーンの未来を共創しましょう",
            description: "優れた竹パルプ・紙製品と専門的なサービスをご提供できることをお待ちしております",
            buttonText: "ご相談はこちら"
        }
    },
    contact: {
        banner: {
            title: 'ご相談はこちら',
            subtitle: 'ご相談やフィードバックはいつでもお待ちしております'
        },
        contactInfo: {
            title: 'お問い合わせ',
            subtitle: 'ご相談やフィードバックはいつでもお待ちしております',
            address: {
                title: '会社住所',
                content: '四川省宜賓市南渓区裴石軽工業団地',
                postcode: '郵便番号：644100'
            },
            phone: {
                title: '電話でのお問い合わせ',
                main: '代表電話：0831-3309663',
                service: 'カスタマーサービスホットライン：0831-3309698'
            },
            email: {
                title: 'メールアドレス',
                service: 'カスタマーサービス：ybzy@yb-zy.com',
                inquiry: '製品に関するお問い合わせ：ybzy@yb-zy.com'
            },
            workingHours: {
                title: '営業時間',
                weekday: '月曜日～金曜日：9:00 - 17:30',
                holiday: '法定休日休業'
            }
        },
        inquiry: {
            title: 'オンラインお問い合わせ',
            subtitle: '以下のフォームにご記入ください。折り返しご連絡いたします',
            form: {
                name: 'お名前',
                company: '会社名',
                email: 'メールアドレス',
                phone: '電話番号',
                subject: 'お問い合わせ件名',
                subjectPlaceholder: 'お問い合わせ件名を選択してください',
                subjects: {
                    product: '製品に関するお問い合わせ',
                    price: '見積もりに関するお問い合わせ',
                    technical: 'テクニカルサポート',
                    cooperation: '業務提携に関するお問い合わせ',
                    other: 'その他のお問い合わせ'
                },
                message: 'お問い合わせ内容',
                submit: '送信',
                submitting: '送信中...'
            },
            sales: {
                title: '販売サービス',
                domesticRawPaper: '国内販売部（原紙）',
                domesticFinishedPaper: '国内販売部（製品紙）',
                international: '国際販売部',
                email: '販売メールアドレス'
            },
            afterSales: {
                title: 'アフターサービス',
                hotlineRawPaper: 'サービスホットライン（原紙）',
                hotlineFinishedPaper: 'サービスホットライン（製品紙）',
                email: 'サービスメールアドレス'
            },
            social: {
                title: 'フォロー',
                wechat: '公式WeChat',
                weibo: '公式Weibo',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: '会社の場所',
            subtitle: 'ご来社・ご視察を歓迎します',
            mapAlt: '宜賓紙業株式会社の地図上の位置',
            transport: {
                public: {
                    title: '公共交通機関',
                    content: 'バス路線：南渓10路[中坝線]「宜賓紙業駅」下車'
                },
                driving: {
                    title: '車でのアクセス',
                    content: '「宜賓紙業株式会社」へナビゲーション、当社には来客用駐車場がございます'
                },
                airport: {
                    title: '空港へのアクセス',
                    content: '宜賓五糧液空港から会社まで約58キロ、空港バスまたはタクシーをご利用ください'
                }
            }
        },
        offices: {
            title: '全球办事处',
            subtitle: '国际化服务网络',
            china: {
                title: '中国总部',
                flagAlt: '中国国旗',
                address: '四川省宜宾市翠屏区岷江西路159号',
                phone: '电话：0831-12345678'
            },
            usa: {
                title: '北美代表处',
                flagAlt: '美国国旗',
                address: '美国加利福尼亚州洛杉矶市橡树大道2588号',
                phone: '电话：+1-213-888-9999'
            },
            japan: {
                title: '日本代表处',
                flagAlt: '日本国旗',
                address: '日本东京都千代田区丸之内1-2-3',
                phone: '电话：+81-3-1234-5678'
            },
            europe: {
                title: '欧洲代表处',
                flagAlt: '德国国旗',
                address: '德国汉堡市汉萨街456号',
                phone: '电话：+49-40-8765-4321'
            },
            singapore: {
                title: '东南亚代表处',
                flagAlt: '新加坡国旗',
                address: '新加坡莱佛士码头10号',
                phone: '电话：+65-6789-0123'
            }
        },
        faq: {
            title: 'よくある質問',
            subtitle: 'お客様の疑問にすばやくお答えします'
        },
        cta: {
            title: '皆様とのご連絡を心よりお待ちしております',
            description: 'ご質問やご要望がございましたら、誠心誠意対応させていただきます',
            buttonText: '今すぐお問い合わせ'
        }
    }
} 